import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Coupon, VoucherRulesForUseDefinitions } from '@app/entity';
import { VOUCHER_RULES_FOR_USE_DEFINITIONS } from '@app/shared/utils';
import { Subscription } from 'rxjs/Subscription';
import { CouponsService } from '@app/core/services';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
  @Input() coupon: Coupon;
  @Input() isExtendedInfo: boolean;
  @Output() onCloseCoupon = new EventEmitter<Coupon>();

  url: string;

  isLoading = false;
  urlSubscription: Subscription;

  rulesForUse: VoucherRulesForUseDefinitions = VOUCHER_RULES_FOR_USE_DEFINITIONS();

  constructor(private couponsService: CouponsService) { }

  ngOnInit() {
  }

  printUrl(coupon: Coupon, element: HTMLElement) {
    if (!element || !coupon || this.isLoading) return;
    if (this.urlSubscription) this.urlSubscription.unsubscribe();

    this.isLoading = true;

    this.urlSubscription = this.couponsService.getCouponPDF(coupon)
      .finally(() => this.isLoading = false)
      .subscribe(url => {
        if (!!element.getAttribute('href') && this.url) {
          this.url = null;
          element.removeAttribute('href');
          return;
        }

        element.setAttribute('href', url);
        this.url = url;
      });
  }

  closeCoupon(coupon: Coupon) {
    this.onCloseCoupon.next(coupon);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/coupon/coupon.component.ts